import {Dispatch, FC, LegacyRef, SetStateAction, useEffect, useRef} from 'react'
import {InvoiceItemEditModalHeader} from './InvoiceItemEditModalHeader'
import {InvoiceItemEditModalForm} from './InvoiceItemEditModalForm'
import {type} from 'os'
import {Invoice, InvoiceRowForm} from '../../core/_models'
import {isNotEmpty} from '../../../../../../../_metronic/helpers'
import {InvoiceRulesV79} from '../../core/invoiceRulesV79'
import {InvoiceSubject} from '../../core/invoiceSubject'

type props = {
  invoiceItem: {
    invoiceItem: InvoiceRowForm | null | undefined
    setInvoiceItem: React.Dispatch<React.SetStateAction<InvoiceRowForm | null | undefined>>
  }
  items: {
    items: InvoiceRowForm[]
    setItems: Dispatch<SetStateAction<InvoiceRowForm[]>>
  }
  invoiceTemplate: number
  invoiceType: number
  invoiceSubject: InvoiceSubject
  invoiceDate: string
  formType: number
  amountMustEqualOne?: boolean
  rules?: InvoiceRulesV79
  productionInvoice?: boolean
}

const InvoiceItemEditModal: FC<props> = ({
  invoiceItem,
  items,
  invoiceTemplate,
  invoiceType,
  invoiceSubject,
  invoiceDate,
  formType,
  amountMustEqualOne,
  rules,
  productionInvoice,
}) => {
  // An item opened from its row is edited, not added (509: the title said «افزودن…» for both).
  const isEditing = !!invoiceItem.invoiceItem && isNotEmpty(invoiceItem.invoiceItem)
  const title = isEditing ? 'ویرایش قلم' : 'افزودن کالا/خدمت به صورتحساب'
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_invoice_item'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-xl modal-fullscreen-lg-down mp-invoice-subdialog'>
          {/* begin::Modal content */}
          <div className='modal-content' style={{minHeight: '75vh'}}>
            <InvoiceItemEditModalHeader title={title} invoiceItem={invoiceItem} />
            {/* begin::Modal body */}
            <div
              className='modal-body scroll-y'
              id='kt_modal_add_invoice_item_body'
            >
              <InvoiceItemEditModalForm
                invoiceItem={invoiceItem}
                items={items}
                invoiceTemplate={invoiceTemplate}
                invoiceType={invoiceType}
                invoiceSubject={invoiceSubject}
                invoiceDate={invoiceDate}
                formType={formType}
                amountMustEqualOne={amountMustEqualOne}
                rules={rules}
                productionInvoice={productionInvoice}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {InvoiceItemEditModal}
